<template>
  <div>
    <v-row>
      <v-col cols="12" lg="12">
        <v-card class="mx-auto" outlined >
          <div class="v-lazy pa-5">
            <v-row>
              <v-col cols="6" class="text-h4">{{ $t("menu.contactus") }}</v-col>
              <v-col cols="6" class="text-h4">
                <v-btn color="primary" dark small class="float-end" @click="Save">
                 {{ $t("btn.Save") }}
               </v-btn>
             </v-col>
           </v-row>
         </div>
         <v-divider></v-divider>
         <v-card-text>
          <v-row>
            <v-col cols="4">
              <v-textarea outlined label="ที่อยู่" v-model="Location"></v-textarea>
            </v-col>
            <v-col cols="4">
              <v-textarea outlined label="Email" v-model="Email"></v-textarea>
            </v-col>
            <v-col cols="4">
              <v-textarea outlined label="เบอร์โทร" v-model="Tel"></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

    </v-col>
  </v-row>
  <v-dialog v-model="dialogComplete" persistent max-width="400">
      <v-card>
        <v-card-title class="text-h5">
          บันทึกข้อมูลเรียบร้อย
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="dialogComplete=false">
            ตกลง
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
</div>
</template>

<script>
  export default {
    components: {

    },
    data() {
      return {
        Location:null,
        Email:null,
        Tel:null,
        dialogComplete:false,
      };
    },

    methods: {
      GetData(){
        this.$store.commit('set_overlay',true);
        this.req.get(this.$store.getters.base_api + 'get-contactus/'+this.$store.getters.authen.locale).then(response=>{
          this.Location = response.data.Location.detail;
          this.Email    = response.data.Email.detail;
          this.Tel      = response.data.Tel.detail;
          this.$store.commit('set_overlay',false);
        }).catch(error => {
          this.$store.commit('set_overlay',false);
        });
      },
      Save(){
        this.$store.commit('set_overlay',true);
        let formData = new FormData();
        formData.append('Location',this.Location);
        formData.append('Email'   ,this.Email);
        formData.append('Tel'     ,this.Tel);
        formData.append('locale',this.$store.getters.authen.locale);
        this.req.post(this.$store.getters.base_api + 'post-contactus',formData)
        .then(response=>{
          this.dialogComplete = true;
          this.$store.commit('set_overlay',false);
        }).catch(error => {
          this.$store.commit('set_overlay',true);
        });
      },
    },
    mounted() {
      this.req = this.$store.getters.req;
      this.GetData();
    },



  };
</script>
